import { PostTypes } from "@shared/types";

export const postTypesObj: Record<PostTypes, string> = {
  LINE_POST: "Line",
  END_POST: "End",
  GATE_POST: "Gate",
  CORNER_POST: "Corner",
  EXISTING_POST: "Existing",
};
export const postTypesArr: PostTypes[] = [
  "LINE_POST",
  "END_POST",
  "GATE_POST",
  "CORNER_POST",
  "EXISTING_POST",
];

export const isPostType = (value: string): value is PostTypes => {
  return (postTypesArr as string[]).includes(value);
};
